import { render, staticRenderFns } from "./BranchAddNew.vue?vue&type=template&id=27c8ff26"
import script from "./BranchAddNew.vue?vue&type=script&lang=js"
export * from "./BranchAddNew.vue?vue&type=script&lang=js"
import style0 from "./BranchAddNew.vue?vue&type=style&index=0&id=27c8ff26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports